// Simple wrapper - no smooth scroll library
export const SmoothScroll = ({ children }) => {
  return <>{children}</>;
};
